import React from "react";
import styled, { keyframes } from "styled-components";
import { $styles, IStyles } from "./$styles";

export interface ISkeletonProps {
  width?: string;
  height?: string;
  aspectRatio?: string;
  radius?: string;
}

const Skeleton: React.FC<ISkeletonProps & IStyles> = ({
  width = "100%",
  height,
  aspectRatio,
  radius = "8px",
  styles,
}): JSX.Element => {
  return (
    <Root
      aria-hidden="true"
      $width={width}
      $height={height}
      $aspectRatio={aspectRatio}
      $radius={radius}
      styles={styles}
    />
  );
};

export default Skeleton;

const shimmer = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
`;

const Root = styled.div<
  IStyles & {
    $width: string;
    $height?: string;
    $aspectRatio?: string;
    $radius: string;
  }
>`
  width: ${({ $width }) => $width};
  ${({ $height }) => ($height ? `height: ${$height};` : "")}
  ${({ $aspectRatio }) => ($aspectRatio ? `aspect-ratio: ${$aspectRatio};` : "")}
  border-radius: ${({ $radius }) => $radius};
  position: relative;
  overflow: hidden;
  background: var(--dark-foggy-night-100);

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      var(--global-border-grey) 50%,
      transparent 100%
    );
    transform: translateX(-100%);
    animation: ${shimmer} 1.4s infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }

  ${$styles}
`;
